import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiUser } = FiIcons;

const ReviewSection = () => {
  const reviews = [
    {
      text: "The application process was very user friendly! I'm not technical so I'm glad it was so intuitive.",
      author: "John Henderson",
      company: "Henderson's Painting, Inc."
    },
    {
      text: "This is how buying online should feel like. Fast easy quoting, and I was able to purchase my policy the same day.",
      author: "Eugene Sheen",
      company: "Sheen Consulting Services"
    },
    {
      text: "I was able to get my general liability insurance the same day. Super impressed!",
      author: "Kevin Cho",
      company: "Richman Landscapers"
    }
  ];

  // Generate filled stars for 5-star rating
  const renderStars = () => {
    return (
      <div className="flex space-x-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-xl fill-current" />
        ))}
      </div>
    );
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trusted by California businesses of all sizes
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
            >
              {renderStars()}
              <p className="text-gray-700 mb-6 italic">
                "{review.text}"
              </p>
              <div className="flex items-center">
                <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mr-4">
                  <SafeIcon icon={FiUser} className="text-blue-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">{review.author}</p>
                  <p className="text-gray-500 text-sm">{review.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mt-16"
        >
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-colors duration-300 inline-block"
          >
            Get Your Quote
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ReviewSection;